type PlaceLocation = {
  id: string;
  lat: number;
  lng: number;
};

export type PlaceLocationGroup<TPlace extends PlaceLocation> = {
  key: string;
  lat: number;
  lng: number;
  places: TPlace[];
};

const coordinateKey = (place: PlaceLocation) =>
  `${Number(place.lat).toFixed(5)}:${Number(place.lng).toFixed(5)}`;

export const groupPlacesByLocation = <TPlace extends PlaceLocation>(
  places: TPlace[],
): PlaceLocationGroup<TPlace>[] => {
  const groups = new Map<string, PlaceLocationGroup<TPlace>>();

  places.forEach((place) => {
    const key = coordinateKey(place);
    const existingGroup = groups.get(key);

    if (existingGroup) {
      existingGroup.places.push(place);
      return;
    }

    groups.set(key, {
      key,
      lat: Number(place.lat),
      lng: Number(place.lng),
      places: [place],
    });
  });

  return Array.from(groups.values());
};
